export default __webpack_public_path__ + "static/media/page.2a8f4dad.png";